import * as Avatar from '@radix-ui/react-avatar';
import { tv } from 'tailwind-variants';

import { ImagePlaceholderIcon } from '@anyx/shared-icons';
import { SlotsToClasses } from '@anyx/shared-ui';


const styles = tv({
  slots: {
    root: 'w-full overflow-hidden',
    image: 'bg-gray-1 h-full w-full object-cover object-center',
    fallback: 'bg-gray-1 flex h-full w-full items-center justify-center',
    icon: 'text-gray-5 h-16 w-16',
  },
});

type ImageLoadableSlots = keyof ReturnType<typeof styles>;

interface ImageLoadableProps {
  src?: string;
  alt?: string;
  className?: string;
  classNames?: SlotsToClasses<ImageLoadableSlots>;
}

export function ImageLoadable({ src, alt, className, classNames }: ImageLoadableProps) {
  const { root, image, fallback, icon } = styles();

  return (
    <Avatar.Root
      data-chromatic="ignore"
      className={root({ className: [className, classNames?.root] })}
    >
      <Avatar.Image src={src} alt={alt} className={image({ className: classNames?.image })} />
      <Avatar.Fallback delayMs={1000}>
        <div className={fallback({ className: classNames?.fallback })}>
          <ImagePlaceholderIcon className={icon({ className: classNames?.icon })} />
        </div>
      </Avatar.Fallback>
    </Avatar.Root>
  );
}
